
var config = {
  getPresellconfig: function () {
    let str = localStorage.getItem('presellconfig');
    if (str) {
      return JSON.parse(str);
    }
  },
  getPubconfiginfo: function () {
    let str = localStorage.getItem('pubconfiginfo');
    if (str) {
      return JSON.parse(str);
    }
  },
  getPubordprintinfo: function () {
    let str = localStorage.getItem('pubordprintinfo');
    if (str) {
      return JSON.parse(str);
    }
  }
}

var install = function (Vue) {
  if (install.installed) {
    return
  }
  install.installed = true

  Object.defineProperties(Vue.prototype, {
    config: {
      value: config
    }
  })
}
export default {
  install
};



// WEBPACK FOOTER //
// ./src/util/util_installer.js